import { createSlice } from '@reduxjs/toolkit'
import service from '../../axios/service'
import { setConfigurationsData } from '../_actions/asyncActions/Trainer/get_trainer_configurations'

const initialState = {
	isLicenseLoadingData: false,
	isUploadLoadingData: false,
	isRawLoadingData: false,
	isLoadingConfigs: false,
	licenseData: null,
	uploadData: null,
	rawData: null,
	trainerSessionData: null,
	isLatestNewsLoaded: true,
	latestNews: {
		news: {
			images: '',
			link: '',
			title: '',
		},
		videos: {
			images: '',
			link: '',
			title: '',
		},
		theory: {
			images: '',
			link: '',
			title: '',
		},
		mobile_news: {
			images: '',
			link: '',
			title: '',
		},
		webapp_news: {
			images: '',
			link: '',
			title: '',
		},
	},
	lastConfiguration: {},
	currentLib: 'Spin & Go',
}

const userDashboard = createSlice({
	initialState,
	name: 'userDashboard',
	reducers: {
		setIsLicenseLoadingData(state, action) {
			state.isLicenseLoadingData = action.payload
		},
		setIsUploadLoadingData(state, action) {
			state.isUploadLoadingData = action.payload
		},

		setIsRawLoadingData(state, action) {
			state.isRawLoadingData = action.payload
		},

		setIsLoadingConfigs(state, action) {
			state.isLoadingConfigs = action.payload
		},

		setLicenseData(state, action) {
			state.licenseData = action.payload
		},
		setCurrentLib(state, action) {
			state.currentLib = action.payload
		},

		setUploadData(state, action) {
			state.uploadData = action.payload
		},

		setRawData(state, action) {
			state.rawData = action.payload
		},

		setTrainerSessionData(state, action) {
			state.trainerSessionData = action.payload
		},
		setLatestNewsLoaded(state, action) {
			state.isLatestNewsLoaded = action.payload
		},
		setLatestNews(state, action) {
			state.latestNews = action.payload
		},
		setLastConfiguration(state, action) {
			state.lastConfiguration = {
				...state.lastConfiguration,
				...action.payload,
			}
		},
	},
})

export const getLatestNews = () => async (dispatch) => {
	const url = 'getBlogLatest'
	dispatch(actions.setLatestNewsLoaded(true))
	try {
		const { data } = await service.get(url)

		dispatch(actions.setLatestNews(data))
		dispatch(actions.setLatestNewsLoaded(false))
	} catch (e) {
		console.log('error', e)
		dispatch(actions.setLatestNewsLoaded(false))
	}
}

export const getLastConfiguration = (lib, spots) => (dispatch) => {
	dispatch(setConfigurationsData({ name: '', order: '' }, 0, 5, false, { spots, isManual: null, lib }, true))
}

export const getUploadData = () => async (dispatch) => {
	const url = 'get_task_list'
	dispatch(actions.setIsUploadLoadingData(true))
	try {
		const { data } = await service.get(url)
		dispatch(actions.setUploadData(data))
		dispatch(actions.setIsUploadLoadingData(false))
	} catch (e) {
		console.log('error', e)
		dispatch(actions.setIsUploadLoadingData(false))
	}
}

export const getRawHandData = () => async (dispatch) => {
	const url = 'get_raw_hand_limit'

	dispatch(actions.setIsRawLoadingData(true))
	try {
		const { data } = await service.get(url)
		dispatch(actions.setRawData(data))
		dispatch(actions.setIsRawLoadingData(false))
	} catch (e) {
		console.log('error', e)
		dispatch(actions.setIsRawLoadingData(false))
	}
}

export const { reducer } = userDashboard
export const { actions } = userDashboard
